import usePrivateAxios from '@/common/api/usePrivateAxios';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { MaintenanceForwardingsShowDirectiveDetailsData, MaintenanceForwardingsShowDirectiveDetailsResponse } from '../types/maintenanceForwardingsShowDirectiveDetails.type';

type UseMaintenanceForwardingsShowDirectiveDetailsProps = {
  workflowId?: string;
  directiveEntryKlass?: string;
}

export const useMaintenanceForwardingsShowDirectiveDetails = ({
  workflowId,
  directiveEntryKlass,
}: UseMaintenanceForwardingsShowDirectiveDetailsProps) => {
  const privateAxios = usePrivateAxios()

  return useQuery<MaintenanceForwardingsShowDirectiveDetailsResponse, AxiosError, MaintenanceForwardingsShowDirectiveDetailsData>({
    queryKey: ['maintenanceForwardingsShowDirectiveDetails', workflowId, directiveEntryKlass],
    queryFn: () => {
      return privateAxios.get(`/maintenance/forwardings/show_directive_details`, {
        params: {
          workflow_id: workflowId,
          directive_entry_klass: directiveEntryKlass,
        },
      })
    },
    placeholderData: keepPreviousData,
    enabled: Boolean(workflowId && directiveEntryKlass),
    staleTime: 5 * 60 * 1000,
    select: (data) => data.data.data,
  });
}
